// import axios from '@/utils/request'
import request from "../utils/request";

class myApi {
  //获取我是否关注了公众号
  static getIsFollow(options) {
    return request.get('/usercenter/v1/wechat/mp/user/subscribe',{params:options})
  }

  //获取我的标签
  static getAddTypeList() {
    return request.get('/cz-goods/v1/products/users/my/tags')
  }

  //获取优惠券列表
  static getCouponsList(options) {
    return request.get('/cz-goods/v1/coupons/user',{params:options})
  }

  static getOrderCouponsList(options) {
    return request.get('/cz-goods/v1/coupons/order',{params:options})
  }

  //获取用户服务列表
  static getUserServiceList(options) {
    return request.get('/cz-order/v1/userService',{params:options})
  }

  //获取服务详情
  static getServiceDetail(option) {
    return request.get('/cz-order/v1/userService/'+option)
  }

  //获取待处理购买订单数
  static getMyOrderCount(){
    return request.get('/cz-order/v1/orders/process/counts')
  }

  //获取退回待处理订单数
  static getReturnOrderCount(){
    return request.get('/cz-order/v1/orderReturn/process/counts')
  }





}

export default myApi;
